export default {
    getAgentSettings: { method: 'get', url: 'agent_settings' },
    postAgentSetting: { method: 'post', url: 'agent_settings' },
    putAgentSetting: { method: 'put', url: 'agent_settings/{id}' },
    deleteAgentSetting: { method: 'delete', url: 'agent_settings/{id}' },
    getAgentTypes:          { method: 'get', url: 'agent_settings/types' },
}